import React from "react";
import Styles from "../styles/Styles";
import { Drawer, CircularProgress, IconButton, Box } from "@mui/material";
import { CustomText, DefaultLogo } from "../../../components";
import { Colors, fonts, Spacing } from "../../../config";
import styled from "styled-components";
import { MenuGroupWithPages } from "../components";
import CloseIcon from "@mui/icons-material/Close";

let data = [
  {
    id: "0",
    name: "GERAL",
    pages: [
      {
        id: "0",
        name: "geral",
        title: "Painel Inicial",
        path: "/geral",
        icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEwLDIwVjE0SDE0VjIwSDE5VjEySDIyTDEyLDNMMiwxMkg1VjIwSDEwWiIgLz48L3N2Zz4=",
      },
    ],
  },
  {
    id: "1",
    name: "RELATÓRIO",
    pages: [
      {
        id: "0",
        name: "general",
        title: "Relatório Geral",
        path: "/general",
        icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEzLDlIMTguNUwxMywzLjVWOU02LDJIMTRMMjAsOFYyMEEyLDIgMCAwLDEgMTgsMjJINkM0Ljg5LDIyIDQsMjEuMSA0LDIwVjRDNCwyLjg5IDQuODksMiA2LDJNMTUsMThWMTZINlYxOEgxNU0xOCwxNFYxMkg2VjE0SDE4WiIgLz48L3N2Zz4=",
      },
      {
        id: "1",
        name: "detail",
        title: "Relatório Detalhado",
        path: "/detail",
        icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTQgNFYyMkgyMFYyNEg0QzIuOSAyNCAyIDIzLjEgMiAyMlY0SDRNMTUgN0gyMC41TDE1IDEuNVY3TTggMEgxNkwyMiA2VjE4QzIyIDE5LjExIDIxLjExIDIwIDIwIDIwSDhDNi44OSAyMCA2IDE5LjEgNiAxOFYyQzYgLjg5IDYuODkgMCA4IDBNMTcgMTZWMTRIOFYxNkgxN00yMCAxMlYxMEg4VjEySDIwWiIgLz48L3N2Zz4=",
      },
    ],
  },
  {
    id: "2",
    name: "PERFIL",
    pages: [
      {
        id: "0",
        name: "profile",
        title: "Meu Perfil",
        path: "/perfil",
        icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLDRBNCw0IDAgMCwxIDE2LDhBNCw0IDAgMCwxIDEyLDEyQTQsNCAwIDAsMSA4LDhBNCw0IDAgMCwxIDEyLDRNMTIsMTRDMTYuNDIsMTQgMjAsMTUuNzkgMjAsMThWMjBINFYxOEM0LDE1Ljc5IDcuNTgsMTQgMTIsMTRaIiAvPjwvc3ZnPg==",
      },
    ],
  },
  {
    id: "3",
    name: "SISTEMA",
    pages: [
      {
        id: "0",
        name: "system",
        title: "Sair",
        path: "/system",
        icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEyLDNDMTAuODksMyAxMCwzLjg5IDEwLDVIM1YxOUgyVjIxSDIyVjE5SDIxVjVDMjEsMy44OSAyMC4xMSwzIDE5LDNIMTJNMTIsNUgxOVYxOUgxMlY1TTUsMTFIN1YxM0g1VjExWiIgLz48L3N2Zz4=",
      },
    ],
  },
];

function Menu({ openMenu, isOpen }: any) {
  const drawer = (
    <>
      <Styles.Container>
        <Styles.ScrollContainer>
          <Styles.Header>
            <DefaultLogo white maxWidth={Spacing(20)} />
            <IconButton size="small" onClick={() => openMenu(!isOpen)}>
              <CloseIcon />
            </IconButton>
          </Styles.Header>

          {data ? (
            data?.map((item, index) => (
              <MenuGroupWithPages
                key={item.name + index}
                headerName={item.name}
                item={item.pages}
                firstItem={index === 0}
                pathname={"/geral"}
              />
            ))
          ) : (
            <div
              style={{
                width: "96%",
                marginTop: "10%",
                justifyContent: "center",
                alignContent: "center",
                display: "flex",
              }}
            >
              <CircularProgress color="secondary" />
            </div>
          )}
        </Styles.ScrollContainer>
        <CustomText
          fontSize={1.5}
          fontFamily={fonts.medium}
          textColor={Colors.whiteBackground}
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBlock: Spacing(3),
          }}
        >
            {process.env.REACT_APP_ENV + " v"}
            {process.env.REACT_APP_VERSION}
        </CustomText>
      </Styles.Container>
    </>
  );

  return (
    <nav aria-label="mailbox folders">
      <Box sx={{ display: { sm: 'none', xs: 'block' } }}>
        <Drawer
          variant="temporary"
          anchor={"left"}
          open={isOpen}
          onClose={() => openMenu(!isOpen)}
          sx={{
            '& .MuiDrawer-paper': {
              borderRight: 'none',
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </nav>
  );
}

export default Menu;
